import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=d9bfc58c&scoped=true&"
import script from "./ProjectEdit.vue?vue&type=script&lang=ts&"
export * from "./ProjectEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bfc58c",
  null
  
)

export default component.exports